/** An enumeration of all feature flag keys currently defined in Launch Darkly. */
// Note: As of Jan 2025, you must also declare feature flags on the backend in flags.go even for
// flags used only on the frontend, because flag states are served from the backend and states will
// not be returned for flags unknown to the backend.
export enum FeatureFlagKey {
  // Please keep alphabetized:
  AI_AGENT_2024_09 = "ai-agent-2024-09",
  AI_AGENT_ENABLEMENT_CORE_2025_10 = "ai-agent-enablement-core-2025-10",
  AI_AGENT_PROMPT_OPTIMIZATION_2025_08 = "ai-agent-prompt-optimization-2025-08",
  AI_TAILORING_BLUEPRINT_TO_TEMPLATE = "ai-tailoring-blueprint-to-template-2024-11",
  AI_TAILORING_DOCX_UX_2025_09 = "ai-tailoring-docx-ux-2025-09",
  APP_GEN_EXCEL_2025_10 = "app-gen-excel-2025-10",
  APP_GEN_GENERATE_AGENTS_2026_01 = "app-gen-generate-agents-2026-01",
  APP_GEN_RED_TEAM_MODE_2025_03 = "app-gen-red-team-mode-2025-03",
  APP_GENERATION_2023_12 = "app-generation-2023-12",
  ARIA_EMAIL_USER_UX_IMPROVEMENTS_2025_05 = "aria-email-user-ux-improvements-2025-05",
  BLUEPRINT_PAGE_REDESIGN_2025_10 = "blueprint-page-redesign-2025-10",
  BLUEPRINT_TRANSFER_DOCUMENTS_2025_08 = "blueprint-transfer-documents-2025-08",
  BLUEPRINT_TRANSFER_UPDATE_FIELDS_2026_03 = "blueprint-transfer-update-fields-2026-03",
  BLUEPRINT_VERSION_LINKS_2025_08 = "blueprint-version-links-2025-08",
  CSV_INLINE_DISPLAY_2025_09 = "csv-inline-display-2025-09",
  CUSTOM_TASK_DESCRIPTION_2025_07 = "custom-task-description-2025-07",
  DATA_TAB_REDESIGN_TO_SUPPORT_TABLES_2025_07 = "data-tab-redesign-to-support-tables-2025-07",
  DISABLE_HOME_PAGE_SUMMARIES_2025_07 = "disable-home-page-summaries-2025-07",
  ESCALATIONS_2025_12 = "escalations-2025-12",
  ESCALATIONS_GA_2026_01 = "escalations-ga-2026-01",
  FIELD_VALIDATION_REGEX_2026_01 = "field-validation-regex-2026-01",
  FILTER_BY_OPEN_TASK_2025_07 = "filter-by-open-task-2025-07",
  HOME_PAGE_COLUMNS_DRAWER_2025_08 = "home-page-columns-drawer-2025-08",
  HOME_PAGE_MULTI_SORT_2025_08 = "home-page-multi-sort-2025-08",
  HOME_PAGE_REMOVE_COLUMNS_2025_08 = "home-page-remove-columns-2025-08",
  HOME_PAGE_UNREAD_MESSAGES_2025_08 = "home-page-unread-messages-2025-08",
  I18N_PHASE_ONE_2024_10 = "i18n-phase-one-2024-10",
  I18N_PHASE_TWO_2025_01 = "internationalization-i18n-m2-2025-01",
  INTERNAL_DEV_ONLY_PAGES_2024_04 = "internal-dev-only-pages-2024-04",
  NOTIFICATION_TASK_2025_12 = "notification-task-2025-12",
  OBJECT_STORAGE_FALLBACK_PROXY_2025_08 = "object-storage-fallback-proxy-2025-08",
  PROJECT_ARIA_2025_03 = "project-aria-2025-03",
  PROJECT_MYELIN_2025_04 = "project-myelin-2025-04",
  RBAC_ADMIN_TYPES_2025_08 = "rbac-admin-types-2025-08",
  SCALE_SPLIT_LINKED_WORKFLOWS_2025_08 = "scale-split-linked-workflows-2025-08",
  SCIM_OKTA_SUPPORT_2025_12 = "scim-okta-support-2025-12",
  SLACK_DEMO_2026_02 = "slack-demo-2026-02",
  SPECTRUM_TASK_INFORMATION_ORDER_TOGGLE_2024_03 = "spectrum-task-information-order-toggle-2024-03",
  SUPER_AGENT_2025_12 = "super-agent-2025-12",
  SUPER_AGENT_MIGRATION_2025_12 = "super-agent-migration-2025-12",
  SUPER_AGENT_NUDGES_202601 = "super-agent-nudges-2026-01",
  TABLES_MILESTONE_1_2025_01 = "tables-milestone-1-2025-01",
  TASK_EXPIRATION_2025_07 = "task-expiration-2025-07",
  TASK_FILTER_GROUP_SMART_VIEWS_2026_01 = "task-filter-group-smart-views-2026-01",
  TASKS_FILTER_SMART_VIEWS_2025_12 = "task-filter-smart-views-2025-12",
  TASKS_FORMS_SMART_VIEWS_2025_07 = "task-forms-smart-views-2025-07",
  TASKS_SMART_VIEWS_2025_07 = "task-smart-views-2025-07",
  TEAMS_2026_02 = "teams-2026-02",
  WEBFORM_UX_IMPROVEMENTS_2025_05 = "webform-ux-improvements-2025-05",
  WORKFLOW_INTAKE_2025_06 = "workflow-intake-2025-06",
  WORKFLOW_PREVIEW_DRAWER_2025_07 = "workflow-preview-drawer-2025-07",
  WORKFLOW_VIEW_ONLY_ACCESS_2025_08 = "workflow-view-only-access-2025-08",
}
